export default __webpack_public_path__ + "static/media/GOALIE TRAINING SETUP.8ebd7976.png";